export const Routes = {
  landing: { path: '/' },
  bookCreation: {
    secured: true,
    path: '/book-creation/',
  },
  bookSetup: {
    secured: true,
    path: '/book-setup/',
  },
  startMigration: {
    secured: true,
    path: '/start-migration/',
  },
  unsupportedBrowser: {
    path: '/unsupported-browser/',
  },
  notFound: {
    path: '/404/',
  },
} as const;

export type PlatformRoutePathname = typeof Routes[keyof typeof Routes]['path'];

export function normaliseRoutePath(path: string) {
  const pathname = new URL(path, 'http://localhost').pathname;

  if (pathname === '/') {
    return pathname;
  }

  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

export function matchesRoutePath(routePath: string, currentPath: string) {
  return normaliseRoutePath(routePath) === normaliseRoutePath(currentPath);
}

export function getPlatformRoutePath(
  path: string
): PlatformRoutePathname | undefined {
  return Object.values(Routes).find((route) => {
    return matchesRoutePath(route.path, path);
  })?.path;
}
